import { AsyncSelect, AsyncSelectProps } from "@sembark-travel/ui-base"
import { useXHR } from "@sembark-travel/xhr"
import { transportPaymentPreferencesXHR as XHR } from "./store"

export function SelectTransportPaymentReferences({
	...otherProps
}: Readonly<Omit<AsyncSelectProps, "fetch">>) {
	const xhr = useXHR()
	return (
		<AsyncSelect
			multiple
			{...otherProps}
			fetch={(q) =>
				XHR(xhr)
					.getTransportPaymentReferences({ q })
					.then((resp) => resp.data)
			}
		/>
	)
}
